export const PAGINATION_DATA = `
  paginatorInfo {
    currentPage
    count
    hasMorePages
    perPage
    total
  }
`
